import { createFileRoute, redirect, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ReservationResourcesClient } from "@/features/reservations/ReservationResourcesClient";
import { listAdminResources, resourceAdminKeys } from "@/features/reservations/reservations.api";

export const Route = createFileRoute("/_shell/reservations/resources")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin")) {
      throw redirect({ to: "/reservations" });
    }
  },
  component: ReservationResourcesScreen,
});

function ReservationResourcesScreen() {
  const { t } = useTranslation();
  const { session } = Route.useRouteContext();

  const query = useQuery({
    queryKey: resourceAdminKeys.list,
    queryFn: listAdminResources,
  });

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Reservation Resources">
      <div style={{ marginBottom: "16px" }}>
        <Link
          to="/reservations"
          className="t-caption"
          style={{ display: "inline-flex", alignItems: "center", gap: "4px", color: "var(--text-secondary)" }}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          {t("reservations.resBackToOverview")}
        </Link>
      </div>

      <ReservationResourcesClient
        initialItems={query.data ?? []}
        userId={session.userId}
        isFetching={query.isFetching}
        isLoading={query.isLoading}
      />
    </div>
  );
}
